'use strict';
angular.module('cvsApp').factory('getRXHistoryDetailsModel',['commonModel',function(CM) {

    var getRXHistoryDetailsModel = function(){

        var self = this;

        var apiResponse = {};

        this.setResponse = function(data){
           CM.setAGPResponse(data,'getRxHistoryDetailsResponse');
        }

        this.getResponse = function(){
            apiResponse = CM.getResponse();
            return self;
        }

        this.showView = function(){
            if(apiResponse.isViewError){
                return !apiResponse.isViewError;
            }
            return true;
        }

        this.getError = function(){
            if(apiResponse.showError){
                return apiResponse.showError;
            }
            return '';
        }

        var getHeader = function () {
            return apiResponse.response.header;
        }

        this.getRXHistoryDetails = function(){
            var rxDetails = [];
            if(!apiResponse.showError && apiResponse.rxHistory){
                if(_.isArray(apiResponse.rxHistory.rxDetails)){
                    return processRxDetails(apiResponse.rxHistory.rxDetails);
                }else{
                    if(apiResponse.rxHistory.rxDetails)
                        rxDetails.push(apiResponse.rxHistory.rxDetails);
                    return processRxDetails(rxDetails);
                }
            }


            return processRxDetails(rxDetails);
        }

        var processRxDetails = function(rxDetails){
            return _.each(rxDetails, function(rx){
                rx.fillStatus = processFillStatus(rx.fillStatus);
                rx.rxStatus = processRxStatus(rx.rxStatus);
                rx.firstFillIndicator = rx.hasOwnProperty('firstFillIndicator') ?( rx.firstFillIndicator === '' ? 'N' : rx.firstFillIndicator) : 'N';
                return rxDetails;
            });
        }

        var processFillStatus = function (fillStatus) {
            var fillStatusMap = {
                'inprocess': 'In Process',
                'readytoship': 'Ready to Ship',
                'shippedtopatient': 'Shipped to Patient',
                'shippedtocvsretailstore': 'Shipped to CVS Retail Store',
                'shippedtoprescriber':'Shipped to Prescriber',
                'shippedtoother': 'Shipped to Other',
                'waitingbin': 'Waiting Bin',
                'returned': 'Returned',
                'cancelled': 'Cancelled',
                'sold':'Sold'
            }
            if(fillStatus){
                var myFillStatus = fillStatusMap[fillStatus.replaceAll(' ', '').replaceAll('_', '').toLowerCase()];
                if(!myFillStatus) {
                    myFillStatus = fillStatus;
                }
                return myFillStatus;
            }
            return fillStatus;

        }

        var processRxStatus = function (refillStatus) {
            var rxStatusMap = {
                'active': 'Active',
                'pendingpatientcontact': 'Pending Patient Contact',
                'inprocess': 'In Process',
                'papending': 'PA Pending',
                'inactive':'Inactive'
            }

            if(refillStatus){
                return rxStatusMap[refillStatus.replaceAll(' ', '').replaceAll('_', '').toLowerCase()];
            }
            return refillStatus;
        }

    }

    return new getRXHistoryDetailsModel();
}]);
